import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import CommonTable from '../table/CommonTable';
import { getDataFromServer } from '../../utils/apiBase';
import toast from 'react-hot-toast';
import ContextHelper from '../../ContextHooks/ContextHelper';
import { Delete, Edit } from '@mui/icons-material';
import DeleteModal from '../DeleteModal';
import { Link, useNavigate } from 'react-router-dom';

const Users = () => {
  const { currentUser } = ContextHelper();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { accessor: 'username', label: 'User Name' },
    { accessor: 'type', label: 'Role' },
    { accessor: 'address', label: 'Address' },
    { accessor: 'adminName', label: 'Admin Name' },
    {
      accessor: 'actions',
      label: 'Actions',
      render: (value, row) => (
        <div className="d-flex gap-2 flex-wrap">
          <Button variant="outline-success" size="sm" title="Edit" onClick={() => handleEdit(row)}>
            <Edit fontSize="small" />
          </Button>
          <Button variant="outline-danger" size="sm" title="Delete" onClick={() => handleDelete(row.id)}>
            <Delete fontSize="small" />
          </Button>
        </div>
      ),
    },
  ];

  const handleEdit = (selectedUser) => {
    navigate('/create-user', {
      state: {
        selectedUser: selectedUser,
      },
    });
  };

  const handleDelete = (id) => {
    setDeleteModal(true);
    // Handle delete action here
    console.log('Delete user with ID:', id);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const ApiUrl = 'getUsersOfAdmin';

    const params = {
      end_point: ApiUrl,
      params: { token: currentUser?.token },
      call_back: handleResponse,
      props: '',
    };

    try {
      await getDataFromServer(params);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast.error('Failed to fetch patient data?.');
      setLoading(false);
    }
  };

  const handleResponse = (res) => {
    setLoading(false);
    if (res.status === 'success') {
      setUsers(res.response.data.reverse());
    } else {
      toast.error(res.message || 'Failed to fetch patients.');
    }
  };
  
  return (
    <>
      {(deleteModal && (
        <DeleteModal
          deleteModal={deleteModal}
          handleDeleteReport={handleDelete}
          closeModal={() => setDeleteModal(false)}
          loading={loading}
          text={'User'}
        />
      )) ||
        ''}
      <Container fluid className="px-0 text-nowrap">
        <div className="bg-white p-md-4 p-2 min-vh-100 shadow-sm position-relative">
          <h3 className="base-color">Users Management</h3>
          <div className="position-absolute mt-3 responsive-heading">
            <Link to={'/create-user'} className="login-btn base-color-bg text-white px-4 btn text-decoration-none">
            Create User
            </Link>
          </div>

          <CommonTable data={users} columns={columns} loading={loading} />
        </div>
      </Container>
    </>
  );
};

export default Users;
